import { colors } from '../../../../abstracts';
import { styled } from 'styled-components';
import { DEFAULT_BORDER_WIDTH } from '../constants';
import { dontForwardProps } from '../../../../util';
const StyledHeader = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-c8ev6m-0"
})(["border-bottom:", " solid ", ";"], DEFAULT_BORDER_WIDTH, colors.neutralBrightest);
export { StyledHeader };